/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Score_ContentInputs */

const en_score_content = /** @type {(inputs: Score_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quality of content`)
};

const de_score_content = /** @type {(inputs: Score_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Qualität des Inhalts`)
};

/**
* | output |
* | --- |
* | "Quality of content" |
*
* @param {Score_ContentInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const score_content = /** @type {((inputs?: Score_ContentInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Score_ContentInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_score_content(inputs)
	return en_score_content(inputs)
});